import { Button, Grid } from "@mui/material";
import CustomLink from "components/CustomLink";
import EditFormControl from "components/form/EditFormControl";
import { ERR_NETWORK } from "constants/messages";
import { authLogin } from "models/authModel";
import { useSnackbar } from "notistack";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { openLoading } from "store/reducers/tools";
import LoginForm from "./LoginForm";

export default function LoginComponent() {
  const { enqueueSnackbar } = useSnackbar();

  const history = useHistory();
  const formRef = useRef();
  const dispatch = useDispatch();
  const isAuth = useSelector((state) => state?.auth?.isAuth);
  const [data, setData] = useState({});

  const handleSubmit = () => {
    const submitData = formRef.current.prepare();
    if (submitData) {
      openLoading(true);
      authLogin({
        data: submitData,
        onFinish: (resLogin, err) => {
          openLoading(false);
          if (resLogin === false) {
            if (!resLogin && err?.message) {
              enqueueSnackbar(err?.message, { variant: "warning" });
            } else {
              enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
            }
            return;
          }
          if (!Boolean(resLogin?.user?.role === "2")) {
            enqueueSnackbar("You don't access this domain", {
              variant: "warning",
            });
            return;
          }
          enqueueSnackbar("Successfully Logged in", { variant: "success" });
          handleFinish(resLogin);
        },
      });
    }
  };

  const handleFinish = (value) => {
    dispatch({
      type: "SET_AUTH",
      payload: (s = {}) => ({
        ...(s ?? {}),
        user: value?.user ?? {},
        token: value?.token ?? "",
        jwt: value?.jwt ?? "",
      }),
    });
  };

  useEffect(() => {
    if (isAuth) {
      history.push("/home");
    }
    // eslint-disable-next-line
  }, [isAuth]);

  return (
    <div>
      <Grid container spacing={2} direction="column">
        <Grid item>
          <LoginForm
            ref={formRef}
            data={data ?? {}}
            onChange={setData}
            type="state"
          />
        </Grid>
        <Grid item>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <EditFormControl
                type="checkbox"
                name="remember_me"
                label="Remember me"
              />
            </Grid>
            <Grid item>
              <CustomLink to="/forgot-password" color="primary">
                Forgot Password?
              </CustomLink>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Button
            onClick={handleSubmit}
            variant="contained"
            size="large"
            fullWidth
          >
            login
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
